import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  InputField,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useStaticContext } from "../../context/StaticContext";
import { getOneService } from "../../lib/sysNavigation/SysNavigation";
import { FiBriefcase } from "react-icons/fi";

const Edit = () => {
  const { updateStaticContent } = useStaticContext();
  const footer: any = getOneService();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const service_id = footer.service_id;
  const [title, setTitle] = useState<any>(footer.title);
  const [description, setDescription] = useState<any>(footer.description);
  const footerRoutes = "/service";

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setErrorMessage(message);
  };

  const updateOneFooterHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  /**
   * @author Ntavigwa Bashombe
   * @param {*} thumbnail
   * @returns
   */
  const sendDBRequest = async () => {
    const data = {
      title: title,
      description: description,
    };

    const { status, message } = await updateStaticContent(
      "service",
      service_id,
      data
    );
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={footerRoutes}
      eyebrow="Settings • Service"
      title="Edit Service"
      subtitle="Update the title and description for this service block."
      icon={<FiBriefcase className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOneFooterHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection title="Service Details" hint="Keep the title clear and concise.">
        <InputField
          props={{
            id: "title",
            title: "Title",
            type: "text",
            value: title ? title : "",
            onChange: (e: any) => {
              setTitle(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>

      <AddSection
        title="Description"
        hint="Aim for 120-160 characters for best readability."
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: description ? description : "",
            rows: 8,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
